import * as api from '../util/apis';
import { ENV } from '../constants/Constants';

export const getScreenshotData = async (
	clientId = 0,
	pageIndex = 0,
	pageSize = 10,
	filterRequestObject: any = [],
	sortRequestObject: any = [],
) => {
	let resp: any;
	try {
		const requestObject = {
			clientId: clientId,
			pageAndSort: {
				pageIndex: pageIndex,
				pageSize: pageSize,
				sort: sortRequestObject,
				filters: filterRequestObject,
			},
		};

		resp = await api.postapiresponses(ENV.dev.screenshot, requestObject);
		const adObj: any = {};
		adObj.list = resp.data.data.list;
		adObj.totalElements = resp.data.data.totalElements;
		return Promise.resolve(adObj);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getScreenshotAssets = async (
	adDetails: { advertisementId: number; campaignId: number },
	pageIndex = 0,
	pageSize = 4,
	filterRequestObject: any = [],
	sortRequestObject: any = [],
) => {
	let resp: any;
	try {
		const requestObject = {
			advertisementId: adDetails.advertisementId,
			campaignId: adDetails.campaignId,
			pageAndSort: {
				pageIndex: pageIndex,
				pageSize: pageSize,
				sort: sortRequestObject,
				filters: filterRequestObject,
			},
		};

		resp = await api.postapiresponses(ENV.dev.screenshot + '/assets', requestObject);
		console.warn(resp.data.data);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCampaignAPIFunctionForClientId = (clientId: any): any => {
	return async (searchString: any) => {
		try {
			const resp: any = await api.getapiresponses(
				ENV.dev.screenshot + '/campaign-search/' + clientId + '/' + searchString,
			);
			return Promise.resolve(resp.data.data);
		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};

export const getScreenshotsByClientIdCampaignId = async (
	clientId: any,
	campaignId: any,
): Promise<any> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.screenshot + '/list/v2/' + clientId + '/' + campaignId,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		console.log(error);
		return Promise.reject(error);
	}
};
